import { useQuery } from '@tanstack/react-query'
import irisApi from '../lib/api'
import type { UploadSession } from '../types'

export function useUploadSession(token: string) {
  const isDemo = import.meta.env.DEV && token === 'demo'

  return useQuery<UploadSession>({
    queryKey: ['upload-session', token],
    queryFn: isDemo
      ? () => Promise.reject(new Error('demo'))
      : () => irisApi.get(`/${token}/`).then((r) => r.data),
    staleTime: isDemo ? Infinity : 15_000,
    refetchInterval: isDemo ? false : 30_000,
    enabled: !!token,
    retry: isDemo ? false : 2,
  })
}
